import React, {useEffect} from 'react';
import {LoadingSpinner} from '../../common/LoadingSpinner';
import {reportLoginError} from '../../error/reportError';

export function RedirectPage({details}) {
  const target = details && details.redirect;

  useEffect(() => {
    if (target) {
      window.location.href = target;
    } else {
      // No redirect target -> window.location.href = undefined would just spin
      // forever with no feedback. Report it and show an error instead.
      reportLoginError(new Error('RedirectPage: missing redirect target'), {flow: 'redirect'});
    }
  }, [target]);

  return (
    <div className="mt-5 text-center">
      {target ? (
        <LoadingSpinner />
      ) : (
        <div className="message">
          <h3>Error</h3>
          <p>Missing redirect target.</p>
        </div>
      )}
    </div>
  );
}
